
const digest = 'd5ba59b22a918d82d70e2c0f319e411c69197406f98c8f47d022136f860a91fe';
const classes = {"wrapper":"_wrapper_3or95_1","item":"_item_3or95_6","button":"_button_3or95_24"};
const css = `._wrapper_3or95_1 {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
._wrapper_3or95_1 ._item_3or95_6 {
  background: #e7f5fb;
  border-radius: 15px;
  padding: 16px 24px;
  display: flex;
  flex-direction: row;
  font-weight: 500;
  font-size: 14px;
  gap: 12px;
  border: 1px solid #dee9ff;
  align-items: center;
  justify-content: space-between;
  color: #2f61b2;
}
._wrapper_3or95_1 ._item_3or95_6 span {
  font-weight: 400;
  color: #000000;
}
._wrapper_3or95_1 ._button_3or95_24 {
  width: fit-content;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  